<template>
    <div class="WorkOrderReportTimeOverrides">
        <Banner
            icon="info-circle"
            variant="info"
            isSlim
        >
            <p>
                Manually override report times for this work order by entering the number of allowed minutes for each time category. We recommend 15 minute intervals to keep with quarter hour billing.
            </p>
            <p>
                Any overrides set will be applied to all reports except for Employee Timesheets. "Start Precheck", "Leave Yard", "Arrive at Yard", and "Complete Postcheck" on hauling ticket reports will be blanked out.
            </p>
        </Banner>

        <Row>
            <Column :md="6">
                <FormNumber
                    v-model="reportTimeOverrides.precheckTime"
                    label="Pre Trip Override"
                    placeholder="Time override in minutes"
                    :class="{ isEmpty: reportTimeOverrides.precheckTime === null }"
                />
            </Column>
            <Column :md="6">
                <FormNumber
                    v-model="reportTimeOverrides.mobilizationTime"
                    label="Mobilization Override (Travel to Work Order)"
                    placeholder="Time override in minutes"
                    :class="{ isEmpty: reportTimeOverrides.mobilizationTime === null }"
                />
            </Column>
        </Row>

        <Row>
            <Column :md="6">
                <FormNumber
                    v-model="reportTimeOverrides.standbyTime"
                    label="Standby Override"
                    placeholder="Time override in minutes"
                    :class="{ isEmpty: reportTimeOverrides.standbyTime === null }"
                />
            </Column>
            <Column :md="6">
                <FormNumber
                    v-model="reportTimeOverrides.demobilizationTime"
                    label="Demobilization Override (Travel to Yard)"
                    placeholder="Time override in minutes"
                    :class="{ isEmpty: reportTimeOverrides.demobilizationTime === null }"
                />
            </Column>
        </Row>

        <Row>
            <Column :md="6">
                <FormNumber
                    v-model="reportTimeOverrides.postcheckTime"
                    label="Post Trip Override"
                    placeholder="Time override in minutes"
                    :class="{ isEmpty: reportTimeOverrides.postcheckTime === null }"
                />
            </Column>
        </Row>
    </div>
</template>


<script>
export default {
    name: 'WorkOrderReportTimeOverrides',

    props: {
        reportTimeOverrides: { type: Object, required: true },
    },

    methods: {
        updateTimes(reportTimeOverrides) {
            this.$emit('update:reportTimeOverrides', reportTimeOverrides);
        },

        clearAllOverrides() {
            const entries = Object.entries(this.reportTimeOverrides);
            const nulledEntries = entries.map(([key, _]) => [key, null]);
            const nulledReportTimeOverrides = Object.fromEntries(nulledEntries);

            this.updateTimes(nulledReportTimeOverrides);
        },
    },
};
</script>


<style lang="scss" scoped>
@import 'globals.scss';

.WorkOrderReportTimeOverrides {
    .Banner {
        margin-bottom: 20px;

        p + p {
            margin-top: 5px;
         }
    }

    .FormNumber.isEmpty ::v-deep input {
        background-color: $bg-color-3;
    }
}
</style>
